import Keycloak from "keycloak-js";

const keycloak: Keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM ?? 'borrowers',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? 'borrower-apps',
});

export default keycloak;
